import React from 'react';
import PropTypes from 'prop-types';
import { Box, Chip } from '@mui/material';

const ManufacturerChipRenderer = ({ selected }) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
    {selected.map((value) => (
      <Chip key={value} label={value} size="small" />
    ))}
  </Box>
);

ManufacturerChipRenderer.propTypes = {
  selected: PropTypes.array.isRequired
};

export default ManufacturerChipRenderer;